import { ReactNode } from 'react';

export interface ProvisioningColumn {
  key: string;
  label: string;
  className?: string;
}

interface ProvisioningTableProps {
  columns: ProvisioningColumn[];
  rows: Array<Record<string, ReactNode>>;
  emptyMessage?: string;
}

export function ProvisioningTable({
  columns,
  rows,
  emptyMessage = 'No records found.',
}: ProvisioningTableProps) {
  if (rows.length === 0) {
    return (
      <p className="text-sm text-gray-500 dark:text-gray-400 py-8 text-center">{emptyMessage}</p>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
        <thead className="bg-gray-50 dark:bg-gray-900/50">
          <tr>
            {columns.map((column) => (
              <th
                key={column.key}
                scope="col"
                className={`px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 ${column.className ?? ''}`}
              >
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-800">
          {rows.map((row, index) => (
            <tr key={index} className="hover:bg-gray-50 dark:hover:bg-gray-700/40">
              {columns.map((column) => (
                <td
                  key={column.key}
                  className={`px-4 py-3 text-sm text-gray-900 dark:text-gray-100 ${column.className ?? ''}`}
                >
                  {row[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}